//@flow

import type { FluxStandardAction } from '../../types'
import { createSelector } from 'reselect'

import { getRoot } from '../rootSelector'

type Poll = {
  id: string,
  impressions: number,
  votes: number,
  headline: string,
  engagement: number,
}

//Constants
export const CLEAR_ANALYTICS_POLLS = 'opinary/CLEAR_ANALYTICS_POLLS'
export const UPDATE_TIMEFRAME_IN_ANALYTICS_STORE =
  'opinary/UPDATE_TIMEFRAME_IN_ANALYTICS_STORE'

export const UPDATE_RESULTS_IN_ANALYTICS_STORE =
  'opinaryUPDATE_RESULTS_IN_ANALYTICS_STORE'

//Actions
export function clearAnalyticsPolls(): FluxStandardAction {
  return {
    type: CLEAR_ANALYTICS_POLLS,
  }
}

export function updateTimeframeInAnalyticsStore(
  payload: string
): FluxStandardAction {
  return {
    type: UPDATE_TIMEFRAME_IN_ANALYTICS_STORE,
    payload,
  }
}

export function updateResultsInAnalyticsStore(
  payload: Array<Poll>
): FluxStandardAction {
  return {
    type: UPDATE_RESULTS_IN_ANALYTICS_STORE,
    payload,
  }
}

//Helpers
export function calculateEngagement(impressions: number, votes: number) {
  if (!impressions || !votes) {
    return 0
  }

  return ((votes / impressions) * 100).toFixed(2)
}

//Selectors
export const getAnalytics = createSelector(
  getRoot,
  ({ analytics }) => analytics
)

//Reducer
const defaultState = {
  polls: [],
  timeframe: {
    from: Date.now(),
    to: Date.now(),
  },
  totals: {
    impressions: 0,
    impressionsAutomated: 0,
    impressionsManual: 0,
    votes: 0,
    votesAutomated: 0,
    votesManual: 0,
    engagementRate: 0,
    engagementRateAutomated: 0,
    engagementRateManual: 0,
  },
}

export default function reducer(
  state: Object = defaultState,
  action: FluxStandardAction
) {
  switch (action.type) {
    case CLEAR_ANALYTICS_POLLS:
      return {
        ...defaultState,
        timeframe: state.timeframe,
      }
    case UPDATE_TIMEFRAME_IN_ANALYTICS_STORE:
      return {
        ...state,
        timeframe: action.payload,
      }

    case UPDATE_RESULTS_IN_ANALYTICS_STORE:
      if (action.payload && action.payload.result) {
        const { totals } = action.payload

        const polls = action.payload.result.map(result => ({
          id: result.pollId,
          headline: result.pollHeader,
          impressions: result.impressions,
          votes: result.votes,
          engagement: calculateEngagement(result.impressions, result.votes),
        }))

        return {
          ...state,
          ...totals,
          polls: polls,
        }
      }

      return state

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/analytics/index.js